import { render, staticRenderFns } from "./WithdrawDialog.vue?vue&type=template&id=1c238b5d&"
import script from "./WithdrawDialog.vue?vue&type=script&lang=ts&"
export * from "./WithdrawDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports